export default __webpack_public_path__ + "static/zebra-case-study-53b4a6611c66de403e1363db613ef66b.webp";